// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"9743ef60","183":"242b2a7e","597":"8b0de184","896":"d71296bc","898":"db725908"}[chunkId] + ".chunk.js";
};